const initialCaseState = {
    treatingDoctorDataSearchDetails: {},
    assistantCertificateDetails: {},
    treatingDoctorVisitDetails: {},
    generalRemarksDetails: {},
    loadingCaseDoctor: false,
    errorsCaseDoctor: {}
}

const CaseDoctorReducer = (state = initialCaseState, action) => {
    switch (action.type) {
        case "ADD_CASE_TREATING_DOCTOR_DATA_SEARCH_PENDING":
        case "ADD_CASE_ASSISTANT_CERTIFICATE_PENDING":
        case "ADD_CASE_TREATING_DOCTOR_VISIT_PENDING":
        case "ADD_CASE_DOCTOR_REMARKS_PENDING":
            return { ...state, loading: true };

        case "ADD_CASE_TREATING_DOCTOR_DATA_SEARCH_FULFILLED":
            return {
                ...state,
                loadingCaseDoctor: false,
                treatingDoctorDataSearchDetails: action.payload,
                errorsCaseDoctor: {}
            };
        case "ADD_CASE_ASSISTANT_CERTIFICATE_FULFILLED":
            return {
                ...state,
                loadingCaseDoctor: false,
                assistantCertificateDetails: action.payload,
                errorsCaseDoctor: {}
            };
        case "ADD_CASE_TREATING_DOCTOR_VISIT_FULFILLED":
            return {
                ...state,
                loadingCaseDoctor: false,
                treatingDoctorVisitDetails: action.payload,
                errorsCaseDoctor: {}
            };
        case "ADD_CASE_DOCTOR_REMARKS_FULFILLED":
            return {
                ...state,
                loadingCaseDoctor: false,
                generalRemarksDetails: action.payload,
                errorsCaseDoctor: {}
            };

        case "ADD_CASE_TREATING_DOCTOR_DATA_SEARCH_REJECTED":
        case "ADD_CASE_ASSISTANT_CERTIFICATE_REJECTED":
        case "ADD_CASE_TREATING_DOCTOR_VISIT_REJECTED":
        case "ADD_CASE_DOCTOR_REMARKS_REJECTED":
            return {
                ...state,
                loadingCaseDoctor: false,
                errorsCaseDoctor: action.payload
            };

        case "RESET_CASE_DOCTOR_ERRORS":
            return {
                ...state,
                errorsCaseDoctor: {}
            };

        case "RESET_TREATING_DOCTOR_DATA_SEARCH_DETAILS":
            return {
                ...state,
                treatingDoctorDataSearchDetails: {}
            };

        case "RESET_ASSISTANT_CERTIFICATE_DETAILS":
            return {
                ...state,
                assistantCertificateDetails: {}
            };

        case "RESET_TREATING_DOCTOR_VISIT_DETAILS":
            return {
                ...state,
                treatingDoctorVisitDetails: {}
            };

        case "RESET_GENERAL_REMARKS_DETAILS":
            return {
                ...state,
                generalRemarksDetails: {}
            };

        default:
            return state;
    }
}

export default CaseDoctorReducer;